import { useTranslation } from 'react-i18next'
import { Typography } from 'antd';

import Box from '../../assets/Box.svg';
import './ListOfOrders.scss';

const NoOrders = (props: any) => {
  const {activeEnabled} = props
  const { t } = useTranslation()
  
  const noOrders = () => {
    const noActiveOrders = {
      message: t('no_active_orders'),
      headline: t('your_active_orders_will_be_displayed_on_this_page'),
    }

    const noCompletedOrders = {
      message: t('no_completed_orders'),
      headline: t('your_completed_orders_will_be_displayed_on_this_page'),
    }

    return activeEnabled ? noActiveOrders : noCompletedOrders
  }
  
  return (
    <div className="noOrders">
      <img src={Box} alt="mobilyIcon" />
      <Typography className="theMessageOfEmpty">{noOrders().message}</Typography>
      <Typography className="headlineOfActive">{noOrders().headline}</Typography>
    </div>
  );
};

export default NoOrders;
